


















































































import { defineComponent } from '@nuxtjs/composition-api';
import Link from '~/components/atoms/Link/Link.vue';
import WebformShortcut from '~/components/molecules/SalesforceWebform/WebformShortcut.vue';
import { SALESFORCE_FORM_INDICATOR } from '~/constants/salesforce';
import config from '~/config';
import { ROUTES } from '~/constants/routes';
import { useRouteExtended } from '~/composables';

export default defineComponent({
  name: 'WebformShortcuts',
  components: {
    WebformShortcut,
    Link,
  },
  props: {
    selectedSubreason: {
      type: String,
      default: '',
    },
  },
  setup (_, { emit }) {
    const onContinue = () => {
      emit('continue');
    };
    const onClose = () => {
      emit('close');
    };
    const { getUrlByRouteKey } = useRouteExtended();

    const returnPolicyUrl = getUrlByRouteKey(ROUTES.RETURN_POLICY);
    const myOrdersUrl = getUrlByRouteKey(ROUTES.MY_ORDERS);
    return {
      SALESFORCE_FORM_INDICATOR,
      returnPortalUrl: config.RETURN_PORTAL_URL,
      myOrdersUrl,
      returnPolicyUrl,
      onContinue,
      onClose,
    };
  },
});
